/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_DescriptionInputs */

const en_to_typescript_description = /** @type {(inputs: To_Typescript_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert JSON to TypeScript interfaces automatically. Generate type-safe TypeScript types from your JSON data.`)
};

const ko_to_typescript_description = /** @type {(inputs: To_Typescript_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에서 TypeScript 인터페이스를 자동으로 생성하세요. JSON 데이터에서 타입 안전한 TypeScript 타입을 만듭니다.`)
};

const ja_to_typescript_description = /** @type {(inputs: To_Typescript_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONからTypeScriptインターフェースを自動生成。JSONデータから型安全なTypeScript型を作成します。`)
};

/**
* | output |
* | --- |
* | "Convert JSON to TypeScript interfaces automatically. Generate type-safe TypeScript types from your JSON data." |
*
* @param {To_Typescript_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_description = /** @type {((inputs?: To_Typescript_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_description(inputs)
	if (locale === "ko") return ko_to_typescript_description(inputs)
	return ja_to_typescript_description(inputs)
});